var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import i18next from "i18next";
import { BookModelCollection } from "../BookModelCollection";
import { currency } from "../../../helpers";
import get from "lodash/get";
import keys from "lodash/keys";
import { CART_ITEMS_PATH } from "../../../components/BookingForm/booking-form.helpers";
var PriceModelCollection = /** @class */ (function (_super) {
    __extends(PriceModelCollection, _super);
    function PriceModelCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceModelCollection.prototype.getPriceAsTitle = function () {
        return this.size === 0 ? "" : i18next.t("bookcart.course_price", {
            count: this.size,
            price: currency(this.all()
                .map(function (price) { return price.getSubPriceSumTotal(); })
                .sort(function (one, two) { return one - two; })[0]).format()
        });
    };
    PriceModelCollection.prototype.getLowestPrice = function () {
        return this.sortAsc(function (price1) { return price1.getSubPriceSumTotal(); }).getPriceAsTitle();
    };
    PriceModelCollection.prototype.getHighestPrice = function () {
        return this.sortDesc(function (price1) { return price1.getSubPriceSumTotal(); }).getPriceAsTitle();
    };
    PriceModelCollection.prototype.getPrice = function (priceId) {
        var collection = (priceId ? this.whereIn("id", [priceId]) : this);
        return collection.getPriceAsTitle();
    };
    PriceModelCollection.prototype.getLastPrice = function () {
        return this.reverse().getPriceAsTitle();
    };
    PriceModelCollection.prototype.getAsSelectOptions = function (_a) {
        var _b = _a.label, label = _b === void 0 ? "" : _b, _c = _a.value, value = _c === void 0 ? "id" : _c;
        return this.all().map(function (m) { return m.getAsSelectOptions({ label: label, value: value }); });
    };
    PriceModelCollection.prototype.transducePrices = function (form, reducer, defaultValue) {
        var cartItemsObject = get(form, CART_ITEMS_PATH, []).filter(function (x) { return +get(x, "position.quantity") > 0; }).reduce(function (cartObject, x) {
            cartObject[get(x, "position.price_id")] = +get(x, "position.quantity");
            return cartObject;
        }, {});
        var ids = keys(cartItemsObject).map(function (x) { return +x; });
        var transducer = reducer(cartItemsObject);
        return this.whereIn("id", ids).all().reduce(transducer, defaultValue);
    };
    PriceModelCollection.prototype.availablePrices = function (_a) {
        var quantity = _a.quantity;
        return this.filter(function (_a) {
            var maxCourseQuantity = _a.maxCourseQuantity, minCourseQuantity = _a.minCourseQuantity;
            return quantity <= maxCourseQuantity && quantity >= minCourseQuantity;
        });
    };
    return PriceModelCollection;
}(BookModelCollection));
export { PriceModelCollection };
